import { useOutdentButton } from "@platejs/indent/react";
import { ButtonWrapper } from "./_Button";
import FontAwesome from "../../../utilities/FontAwesome";

export function OutdentButton() {
  const { props: buttonProps } = useOutdentButton();

  return (
    <ButtonWrapper {...buttonProps} tooltip={"Outdent"}>
      <FontAwesome fixedWidth prefix={"fas"} name={"fa-outdent"} />
    </ButtonWrapper>
  );
}
